import React from 'react';
import {Link} from "react-router-dom";
import '../styles/_404.css';
import '../styles/Global.css';
import gh from "../Assets/Game View/Gameplay-Home.png";

export default function tutorialArchive() {
    return (
        <div className="content">
            <div className="about-frame">
                <div id="about">
                    <p>TUTORIAL ARCHIVE.</p>
                </div>
                <div className="everything-container">
                <span className="normal-text">
                    There are certain features in Poly Beats that would usually require you to be pretty smart to pull off.
                <br/><br/>
                    Luckily, I'm not, and I don't expect you to be, either. So here's some tutorials on how to do certain things in our game.

                </span>

                    <Link to="/Tutorial-Archive/Themes">
                        <button className="fof-menu-button"><span>HOW TO MAKE A THEME</span></button>
                    </Link>
                </div>
            </div>
        </div>
    );
}